"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineMessages = defineMessages;
// This simply returns what's passed-in because it's meant to be a hook for
// babel-plugin-react-intl.
function defineMessages(messageDescriptors) {
  return messageDescriptors;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form-validators/lib/redux-form-validators.js
// module id = 384
// module chunks = 0